export default __webpack_public_path__ + "static/media/litho-demo-single-project-page-04.bfa49ade.jpg";